import React, { useState, useEffect } from "react";
import Header from "../components/utils/Header";
import Section from "../components/scrumBoard/Section";
import Footer from "../components/utils/Footer";
import SprintList from "../components/scrumBoard/SprintList";
import SprintBacklogList from "../components/scrumBoard/SprintBacklogList";
import SprintBacklogSection from "../components/scrumBoard/SprintBacklogSection";
import { collection, onSnapshot } from "firebase/firestore";
import { database } from "../database/firebase-config";
import { Timestamp } from "firebase/firestore";
import { useFirebase } from "../database/FirebaseContext";
import { getLocalUser } from "../database/localStorage";
import ResetPasswordForm from "../components/teamManagement/ResetPasswordForm"


function ScrumBoard({colourBlindMode, onColourBlindMode, offColourBlindMode}) {
    document.title = "Scrum Board";

    const [selectedItem, setSelectedItem] = useState({
        sprintID: "",
        sprintName: "",
        sprintStartDate: Timestamp.fromDate(new Date()),
        sprintEndDate: Timestamp.fromDate(new Date()),
        sprintStatus: "",
        sprintTotalStoryPoint: 0,
    });

    const chooseSelectedItem = (item) => {
        setSelectedItem(item);
    };

    const [sprintBacklog, setSprintBacklog] = useState(false);

    const openSprintBacklog = () => {
        setSprintBacklog(true);
    };

    // const closeSprintBacklog = () => {
    //     setSprintBacklog(false);
    // };

    const [sprints, setSprints] = useState([]);
    const [pBTasks, setPBTasks] = useState([]);
    const [sprintTasks, setSprintTasks] = useState([]);
    const { getUser, getAllUsersData } = useFirebase();
	const [users, setUsers] = useState([]);
	const [userRoles, setUserRoles] = useState("");
	const [currentUser, setCurrentUser] = useState({});
    const [modalChangePassword, setModalChangePassword] = useState("false")
    
    const openModalChangePassword = () => {
        setModalChangePassword(true);
    };

    // make the task detail hidden
    const closeModalChangePassword = () => {
        setModalChangePassword(false);
    };

    useEffect(() => {
        const sprintCollectionRef = collection(database, "sprints");
        const unsubcribeSprints = onSnapshot(
            sprintCollectionRef,
            (snapshot) => {
                const data = snapshot.docs.map((doc) => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                data.sort(
                    (a, b) =>
                        (a.createdAt?.toMillis() || 0) -
                        (b.createdAt?.toMillis() || 0)
                );
                setSprints(data);
            }
        );

        const pbCollectionRef = collection(database, "product-backlog");
        const unsubcribePB = onSnapshot(pbCollectionRef, (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            data.sort(
                (a, b) =>
                    (a.createdAt?.toMillis() || 0) -
                    (b.createdAt?.toMillis() || 0)
            );
            setPBTasks(data);
        });

        const sbCollectionRef = collection(database, "sprint-tasks");
        const unsubcribeSB = onSnapshot(sbCollectionRef, (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            data.sort(
                (a, b) =>
                    (a.createdAt?.toMillis() || 0) -
                    (b.createdAt?.toMillis() || 0)
            );
            setSprintTasks(data);
        });

        const updateCurrentUser = async () => {
			const user = await getUser(
				getLocalUser().userName,
				getLocalUser().userPassword
			);
			setCurrentUser(user);
			setUserRoles(user.userRole);
		};


		updateCurrentUser();
        return () => {
            unsubcribeSprints();
            unsubcribePB();
            unsubcribeSB();
        };
    }, []);

    const { getAllSprintTask, sortSprintTasks, filterBySprintTaskTag } =
        useFirebase();

    const getSortedTasks = async (priority) => {
        const sortedTasks = await sortSprintTasks(priority);
        const sortedData = sortedTasks.map((task) => ({
            ...task,
        }));
        setSprintTasks(sortedData);
    };

    const getFilteredTasks = async (categoryTag) => {
        const filteredTasks =
            categoryTag !== "None"
                ? await filterBySprintTaskTag(categoryTag)
                : await getAllSprintTask(selectedItem.id);
        const filteredData = filteredTasks.map((task) => ({
            ...task,
        }));
        setSprintTasks(filteredData);
    };

    return (
        <div>
            <Header 
                roles={currentUser.userRole}
                openModal={openModalChangePassword}
                colourBlindMode={colourBlindMode}
                onColourBlindMode={onColourBlindMode}
                offColourBlindMode={offColourBlindMode}
            />
            
            {sprintBacklog === false && (
                <>
                    <Section title={"Scrum Board"} colourBlindMode={colourBlindMode} />
                    {modalChangePassword === true && (
                        <ResetPasswordForm 
                            onClose={closeModalChangePassword}
                        />
                    )}
                    <SprintList
                        sprints={sprints}
                        openSprintBacklogs={openSprintBacklog}
                        chooseSelectedItems={chooseSelectedItem}
                        colourBlindMode={colourBlindMode}
                    />
                </>
            )}

            {sprintBacklog === true && (
                <>
                    <SprintBacklogSection
                        selectedItems={selectedItem}
                        onSort={getSortedTasks}
                        onFilter={getFilteredTasks}
                        colourBlindMode={colourBlindMode}
                    />

                    {modalChangePassword === true && (
                        <ResetPasswordForm 
                            onClose={closeModalChangePassword}
                        />
                    )}

                    <SprintBacklogList
                        sprintID={selectedItem.id}
                        pBTasks={pBTasks}
                        sprintTasks={sprintTasks}
                        sprintStatus={selectedItem.sprintStatus}
                        colourBlindMode={colourBlindMode}

                    />
                </>
            )}
            <Footer />
        </div>
    );
}
export default ScrumBoard;
